import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.chatbot');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-chatbot',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.chatbot/view.scss */
:host {
  display: block;
}

.group:hover .chat-delete-btn {
  opacity: 1;
}`],
})
export class ComponentChatbotComponent implements OnInit {
    public showChat: boolean = false;
    public chatInput: string = '';
    public currentView: string = 'chat'; // 'chat' | 'list'

    public chatSessions: any[] = [];
    public activeChatId: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.createNewChat(true);
    }

    private generateId(): string {
        return Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
    }

    public get activeChat(): any {
        return this.chatSessions.find(s => s.id === this.activeChatId) || null;
    }

    public get chatMessages(): any[] {
        return this.activeChat?.messages || [];
    }

    public async toggleChat() {
        this.showChat = !this.showChat;
        if (this.showChat) this.currentView = 'chat';
        await this.service.render();
    }

    public async closeChat() {
        this.showChat = false;
        this.currentView = 'chat';
        await this.service.render();
    }

    public async showListView() {
        this.currentView = 'list';
        await this.service.render();
    }

    public async backToChat() {
        this.currentView = 'chat';
        await this.service.render();
    }

    public async createNewChat(silent: boolean = false) {
        const session = {
            id: this.generateId(),
            title: '새 대화',
            messages: [],
            createdAt: new Date()
        };
        this.chatSessions.unshift(session);
        this.activeChatId = session.id;
        this.chatInput = '';
        this.currentView = 'chat';
        if (!silent) await this.service.render();
    }

    public async selectChat(sessionId: string) {
        this.activeChatId = sessionId;
        this.currentView = 'chat';
        this.chatInput = '';
        await this.service.render();
    }

    public async deleteChat(sessionId: string, event: any) {
        event.stopPropagation();
        this.chatSessions = this.chatSessions.filter(s => s.id !== sessionId);
        if (this.activeChatId === sessionId) {
            if (this.chatSessions.length === 0) {
                this.createNewChat(true);
            } else {
                this.activeChatId = this.chatSessions[0].id;
            }
        }
        await this.service.render();
    }

    public async sendMessage() {
        if (!this.chatInput.trim()) return;
        const chat = this.activeChat;
        if (!chat) return;

        const userMsg = this.chatInput.trim();
        chat.messages.push({ role: 'user', content: userMsg });

        if (chat.title === '새 대화') {
            chat.title = userMsg.length > 20 ? userMsg.substring(0, 20) + '...' : userMsg;
        }

        this.chatInput = '';
        await this.service.render();

        setTimeout(async () => {
            chat.messages.push({ role: 'assistant', content: '현재 AI 에이전트 기능은 준비 중입니다. 곧 서비스를 제공할 예정입니다.' });
            await this.service.render();
        }, 500);
    }

    public getLastMessage(session: any): string {
        if (!session.messages.length) return '새 대화를 시작하세요';
        const last = session.messages[session.messages.length - 1];
        const text = last.content;
        return text.length > 30 ? text.substring(0, 30) + '...' : text;
    }

    public formatTime(date: Date): string {
        const d = new Date(date);
        const h = d.getHours().toString().padStart(2, '0');
        const m = d.getMinutes().toString().padStart(2, '0');
        return `${h}:${m}`;
    }
}

export default ComponentChatbotComponent;